var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"sm":"6","lg":"7","xl":"8"}},[_c('GmapMap',{ref:"sharerMap",staticClass:"status-map",attrs:{"center":_vm.centerMap,"options":_vm.optionsMap,"zoom":_vm.zoomMap,"map-type-id":"terrain"},on:{"click":function($event){_vm.isInfoShown = false}}},_vm._l((_vm.playerList),function(marker,index){return _c('GmapMarker',{key:index,attrs:{"position":marker.position,"clickable":true,"draggable":false,"icon":{ url: _vm.url(marker.problems) },"title":marker.name},on:{"click":function($event){marker.isInfoShown = _vm.clickInfo(marker)}}},[_c('GmapInfoWindow',{attrs:{"opened":marker.isInfoShown,"options":{
              content:
                '<span class=\'iconTitle\'></span>' +
                '<span> </span>' +
                '<span class=\'icon\'>' +
                marker.name +
                '</span>' +
                '<br/><br/>' +
                '<span class=\'iconNetwork\'></span>' +
                '<span style=\'color:black\'> ' +
                _vm.$t('status.last-connection') +
                ' : ' +
                marker.lastConnection +
                '</span>' +
                '<br/><br/>' +
                '<span class=\'iconUpdate\'></span>' +
                '<span style=\'color:black\'> ' +
                _vm.$t('status.last-update') +
                ' : ' +
                marker.lastUpdate +
                '</span>',
            }},on:{"closeclick":function($event){marker.isInfoShown = false}}})],1)}),1)],1),_c('v-col',{attrs:{"sm":"6","lg":"5","xl":"4"}},[(_vm.dataLoaded)?_c('players-and-problem-container',{attrs:{"player-connected":_vm.playerConnected,"player-disconnected":_vm.playerDisconnected,"player-problems":_vm.playerProblems,"player-no-response":_vm.playerNoResponse},on:{"itemSelected":_vm.selectMarker}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }